import { render, staticRenderFns } from "./VideoReviewsTab.vue?vue&type=template&id=432efc9f&scoped=true"
import script from "./VideoReviewsTab.vue?vue&type=script&lang=js"
export * from "./VideoReviewsTab.vue?vue&type=script&lang=js"
import style0 from "./VideoReviewsTab.vue?vue&type=style&index=0&id=432efc9f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "432efc9f",
  null
  
)

export default component.exports